exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".compare-by-select {\n  width: 100%;\n  max-width: 350px; }\n  .compare-by-select .ant-select-selection-selected-value {\n    color: #33404d !important; }\n  .compare-by-select span.ant-select-arrow::before {\n    content: \"\\E606\"; }\n  .compare-by-select .ant-select-selection {\n    border: 1px solid #979797; }\n\n.compare-by-option {\n  display: inline-block;\n  color: #33404d !important; }\n\n.ant-select-dropdown-menu .compare-by-text {\n  font-size: 14px;\n  position: absolute;\n  top: 6px;\n  left: 30px; }\n\n.ant-select-selection img {\n  margin-top: 6px; }\n\n.ant-select-selection .compare-by-text {\n  font-size: 14px;\n  position: absolute;\n  top: 0px;\n  left: 21px; }\n\n.compare-by-null-option {\n  font-size: 14px;\n  display: inline;\n  color: #33404d !important; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./client/modules/AnalyticsMetric/components/Dropdown/CompareBySelect/style.scss
// module id = 988
// module chunks = 0